export var buildEnv = {
  buildMode: 'release',
  datacenter: 'us',
  sdkVersion: '1.25.4'
};